import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getLocaleObject } from '@costar/react-datepicker';
import registerCulture from './register-culture.esm.js';
import { DEFAULT_LOCALE_SPEC, DEFAULT_SHORT_DATE } from '../constants/index.esm.js';

function getLocaleDateFormat () {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'full';
  var localeSpec = DEFAULT_LOCALE_SPEC;
  var retVal = DEFAULT_SHORT_DATE;
  if (_typeof(locale) !== 'object') {
    registerCulture(locale);
    localeSpec = getLocaleObject(locale);
  } else {
    var _getLocaleObject;
    localeSpec = (_getLocaleObject = getLocaleObject(locale)) !== null && _getLocaleObject !== void 0 ? _getLocaleObject : DEFAULT_LOCALE_SPEC;
  }
  // eslint-disable-next-line no-console
  // console.log(` localSpec ${localeSpec.code}`)

  if (localeSpec && localeSpec.formatLong) {
    var format = localeSpec.formatLong.date({
      width: width
    });
    if (typeof format === 'string' && format.length > 0) {
      retVal = format;
    }
  }
  return retVal;
}

export default getLocaleDateFormat;
//# sourceMappingURL=get-locale-date-format.esm.js.map
